export default {
  wrong_login:
    'Неверный пароль или адрес электронной почты. Попробуй еще раз.',
  email: 'Эл. почта',
  password: 'Пароль',
  remember_me: 'Запомнить меня',
  login: 'Войти',
  register: 'Зарегистрироваться',
  forgot_password: 'Восстановить пароль?',
  send: 'Восстановить',
  back_to_login: 'Вернуться на страницу авторизации',
  create_account: 'Создать кабинет',
  first_name: 'Имя',
  last_name: 'Фамилия',
  company_name: 'Имя компании',
  phone_number: 'Номер телефона',
  repeate_password: 'Повторить пароль',
  email_confirmed:
    'Эл. почта была подтверждена. Через несколько секунд вы перейдете на страницу входа в систему.',
  redirect_to_login:
    'Мы отправили вам электронное письмо, пожалуйста, проверьте свой почтовый ящик. Через несколько секунд вы перейдете на страницу входа в систему.'
}
